<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Ticket')" style="position: relative">
          <b-form @submit.prevent="noop" autocomplete="off" ref="det">
            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="is_valid[details.is_valid]"
                  label="Is Valid"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="status[details.status]"
                  label="Status"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="details.ticket_id"
                  label="Serial"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="details.pin"
                  :label="$t('Pin')"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="details.event_name"
                  label="Event"
                  :to="`/lottery-events/${details.eevent_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.event_time"
                  label="Event Time"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="2">
                <FloatingLabel
                  :value="details.event_code"
                  label="Event Code"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="details.registration_time"
                  label="Registration Time"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="details.save_time"
                  label="Save Time"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="3">
                <FloatingLabel
                  :value="valueOfId(details.etenant_id, 'tenants')"
                  label="Tenant"
                  :to="`/tenants/${details.etenant_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="3">
                <FloatingLabel
                  :value="valueOfId(details.eshop_id, 'shops')"
                  label="Shop"
                  :to="`/shops/${details.eshop_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.eterminal_id"
                  label="Terminal Id"
                  :to="`/shops/${details.eshop_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="2">
                <FloatingLabel
                  :value="valueOfId(details.euser_id, 'users')"
                  label="User"
                  :to="`/users/${details.euser_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-form-group
              :label="$t('Selected Numbers')"
              class="grouping p-3 mb-3 mt-0"
            >
              <div
                v-if="
                  details.selected_numbers && details.selected_numbers.length
                "
              >
                <ListEditor
                  :items="details.selected_numbers"
                  :showIndex="false"
                  prefix="#"
                  size="sm"
                  :disabled="true"
                  :required="true"
                  :flex="true"
                  flexWidth="100px"
                />
              </div>
            </b-form-group>

            <b-row>
              <b-col cols="12" md="8">
                <b-form-group
                  :label="$t('Ticket Systems')"
                  class="grouping p-3 mb-3 mt-0"
                >
                  <div
                    v-if="
                      details.ticket_systems && details.ticket_systems.length
                    "
                  >
                    <ListEditor
                      :items="details.ticket_systems"
                      :showIndex="false"
                      prefix="#"
                      size="sm"
                      :disabled="true"
                      :required="true"
                      :flex="true"
                      flexWidth="100px"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.number_of_lines"
                  label="Number Of Lines"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="2">
                <FloatingLabel
                  :value="roundThousands(details.total_amount)"
                  label="Total Amount"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="2">
                <FloatingLabel
                  :value="roundThousands(details.stake)"
                  label="Stake"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="2">
                <FloatingLabel
                  :value="roundThousands(details.tax)"
                  label="Tax"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="3">
                <FloatingLabel
                  :value="roundThousands(details.max_winning)"
                  label="Max Winning"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="3">
                <FloatingLabel
                  :value="roundThousands(details.min_winning)"
                  label="Min Winning"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row v-if="details.is_valid == 4 || details.is_valid == 2">
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$t('Authorized')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="details.authorized"
                    :value="true"
                    :unchecked-value="false"
                    disabled
                    >{{
                      $t("If the ticket was manually authorized")
                    }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="valueOfId(details.eauthorized_by_user_id, 'users')"
                  label="Authorized by User Id"
                  :to="`/users/${details.eauthorized_by_user_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
            </b-row>

            <FloatingLabel
              v-model="details.authorization_reason"
              label="Authorization Reason"
              autocomplete="false"
              type="textarea"
              size="sm"
              :readonly="true"
              v-if="details.is_valid == 4"
            />

            <FloatingLabel
              v-model="details.refusal_reason"
              label="Refusal Reason"
              autocomplete="false"
              type="textarea"
              size="sm"
              :readonly="true"
              v-if="details.is_valid == 2"
            />

            <b-row v-if="details.is_valid == 0">
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="valueOfId(details.ecancel_by_user_id, 'users')"
                  label="Canceled by User Id"
                  :to="`/users/${details.ecancel_by_user_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="details.cancel_time"
                  label="Cancel Time"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <FloatingLabel
              v-model="details.cancel_reason"
              label="Cancel Reason"
              autocomplete="false"
              type="textarea"
              size="sm"
              :readonly="true"
              v-if="details.is_valid == 0"
            />

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="roundThousands(details.gross_winning_amount)"
                  label="Gross Winning Amount"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="roundThousands(details.net_winning_amount)"
                  label="Net Winning Amount"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="roundThousands(details.winning_tax)"
                  label="Winning Tax"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.processing_time"
                  label="Processing Time"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.expiration_time"
                  label="Expiration Time"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.paid_time"
                  label="Paid Time"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="valueOfId(details.epaid_by_user_id, 'users')"
                  label="Paid by User"
                  :to="`/users/${details.epaid_by_user_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="valueOfId(details.epaid_shop_id, 'shops')"
                  label="Shop"
                  :to="`/shops/${details.epaid_shop_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="valueOfId(details.eplayer_id, 'players')"
                  label="Player"
                  :to="`/players/${details.eplayer_id}`"
                  type="link"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.reserve_transaction_id"
                  label="Reserve Transaction ID"
                  type="plain"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.settle_transaction_id"
                  label="Settle Transaction ID"
                  type="plain"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" md="4">
                <!--
                <FloatingLabel
                  :value="valueOfId(details.eonline_player_id, 'onlinePlayers')"
                  label="Online Player"
                  :to="`/online-players/${details.eonline_player_id}`"
                  type="link"
                  size="sm"
                  :readonly="true"
                />
                -->
                <FloatingLabel
                  :value="
                    valueOfId(
                      details.ethird_party_player_id,
                      'thirdPartyPlayers'
                    )
                  "
                  label="Third Party Player"
                  :to="`/third-party-players/${details.ethird_party_player_id}`"
                  type="link"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="2">
                <FloatingLabel
                  :value="extra.free_bet"
                  label="Free Bet ID"
                  type="textarea"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" md="2">
                <FloatingLabel
                  :value="roundThousands(extra.bonus_amount_used)"
                  label="Bonus Amount"
                  type="textarea"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="extra.bonus_data"
                  label="Bonus Data"
                  type="textarea"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="extra.bonus_settle_data"
                  label="Bonus Settle Data"
                  type="textarea"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="extra.bonus_user_data"
                  label="Bonus User Data (what the user has selected)"
                  type="textarea"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="extra.bonus_won_data"
                  label="Bonus Won Data (what core responded)"
                  type="textarea"
                  size="sm"
                  :readonly="true"
                />
              </b-col>
            </b-row>

            <b-form-group
              :label="$t('Is Web Ticket')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.is_web_ticket"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Is Web Ticket") }}</b-form-checkbox
              >
            </b-form-group>

            <FloatingLabel
              :value="details.eprocessing_routine_id"
              label="Processing Routine Id"
              type="plain"
              size="sm"
            />

            <FloatingLabel
              :value="details.reprinted"
              label="Reprinted"
              type="textarea"
              size="sm"
            />

            <b-form-group
              :label="$t('Test')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.test"
                :value="true"
                :unchecked-value="false"
                disabled
                >{{ $t("Enable test mode") }}</b-form-checkbox
              >
            </b-form-group>

            <div style="text-align: right">
              <b-button
                type="button"
                variant="danger"
                class="mr-3"
                v-if="details.is_valid == 1 && details.status == 3"
                @click="invalidatePayment"
                >{{ $t("Invalidate Payment") }}</b-button
              >
              <b-button
                type="button"
                variant="danger"
                class="mr-3"
                v-if="details.is_valid == 1"
                @click="voidTicket"
                >{{ $t("Void Ticket") }}</b-button
              >
              <b-button
                type="button"
                variant="danger"
                class="mr-3"
                v-if="details.is_valid == 1"
                @click="showCancelTicket"
                >{{ $t("Cancel Ticket") }}</b-button
              >
              <b-button
                type="button"
                variant="info"
                class="mr-3"
                v-if="details.status == 4"
                @click="extendExpiration"
                >{{ $t("Extend Expiration") }}</b-button
              >
              <b-button
                type="button"
                variant="info"
                @click="showReprocess"
                v-if="details.is_valid == 1"
                >{{ $t("Reprocess") }}</b-button
              >
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="bv-modal-reprocess" size="lg" hide-footer centered>
      <template slot="modal-title">{{
        $t("Reprocess tickets with new results set")
      }}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <div class="d-block" style="position: relative">
        <div>
          <div class="mb-3 mt-0 mx-1 text-black">
            {{ $t("Paste here (comma delimited numbers) ...") }}
          </div>
          <FloatingLabel
            v-model="resultSetString"
            label="Results as comma delimited numbers"
            size="sm"
            type="textarea"
            style="margin-bottom: 0.5rem !important"
            :state="resultSetStringState"
            aria-describedby="input-live-feedback"
          >
            <template v-slot:feedback>
              <div id="input-live-feedback" class="invalid-feedback">
                {{ $t("One or more numbers are invalid") }}
              </div>
            </template>
          </FloatingLabel>
          <div class="mb-3 text-black">
            {{ $t("... or type in your result numbers bellow.") }}
          </div>
        </div>
        <b-form @submit.prevent="onReprocess" autocomplete="off" ref="l">
          <b-form-group :label="$t('Results')" class="grouping p-3 mb-3 mt-0">
            <ResultsEditor
              :items="resultSet"
              :max="r"
              size="sm"
              :flex="true"
              flexWidth="90px"
              :showIndex="true"
              prefix="#"
            />
          </b-form-group>
          <div class="text-right">
            <b-button type="submit" variant="success" class="mt-3">{{
              $t("Reprocess")
            }}</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
    <b-modal
      id="bv-modal-reason"
      ref="pinModal"
      title="Introduce un motiv"
      @show="resetReasonModal"
      @hidden="resetReasonModal"
      @ok="cancelTicket"
      centered
      cancel-title="Renunta"
    >
      <template slot="modal-title">{{ $t("Type in a reason") }}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <form @submit.stop.prevent="cancelTicket">
        <FloatingLabel
          v-model="reason"
          label="Reason"
          size="sm"
          type="textarea"
        />
      </form>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import ListEditor from "@/components/ListEditor";
import { successConf, errorConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";
import ResultsEditor from "@/components/ResultsEditor";

export default {
  name: "ticket",
  props: ["selectedeid"],
  components: {
    ListEditor,
    FloatingLabel,
    ResultsEditor,
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      this.newID = true;
    }
  },
  data: function () {
    return {
      eid: "",
      details: {
        ticket_id: "", //	text	Encoded ticket ID as string printed on the ticket
        pin: "", //	text	Ticket PIN (used when paid)
        registration_time: "", //	bigint	When the ticket was registered
        save_time: "", //	bigint	When the ticket was last saved
        etenant_id: "", //	bigint	Tenant to which the ticket belongs
        eshop_id: "", //	bigint	Shop where the ticket was registered
        eterminal_id: "", //	bigint	Terminal where the ticket was registered
        euser_id: "", //	bigint	User which registered the ticket
        eevent_id: "", //	bigint	For which event is the ticket
        event_name: "", //	text	Event name
        event_time: "", //	bigint	Event time
        event_code: "", //	integer	Event code
        is_web_ticket: false,
        selected_numbers: [], //	integer[]	Numbers selected on the ticket
        ticket_systems: [], //	text	Which ticket syatems have been selected
        number_of_lines: "", //	integer	Computed number of lines on the ticket
        total_amount: "", //	bigint	How much to pay for the ticket
        stake: "", //	bigint	Ticket stake
        tax: "", //	bigint	Ticket tax (total amount - stake)
        max_winning: "", //	bigint	Computed maximum winning amount
        min_winning: "", //	bigint	Computed minimum winning amount
        is_valid: "", //	integer	Ticket validation result (0 = canceled, 1 = valid, 2 = rejected)
        authorized: false, //	boolean NULL [false]	If the ticket was manually authorized
        eauthorized_by_user_id: "", //	bigint NULL	Who authorized the ticket?
        authorization_reason: "", //	text NULL	Why it was authorized
        refusal_reason: "", //	text NULL	Why it was refused
        cancel_time: "", //	bigint NULL	Cancel time if the ticket was canceled
        ecancel_by_user_id: "", //	bigint NULL	Who canceled the ticket
        cancel_reason: "",
        status: "", //	integer	Ticket status (0 = runner, 1 = winner, 2 = lost)
        gross_winning_amount: "", //	bigint	Gross winning amount (before tax)
        net_winning_amount: "", //	bigint	Net winning amount (after tax)
        winning_tax: "", //	bigint	Computed winning tax (based on winning amount)
        processing_time: "", //	bigint NULL	When was the ticket processed
        eprocessing_routine_id: "", //	text NULL	Container ID which processed the ticket
        expiration_time: "", //	bigint	When will the ticket expire (applies to winners)
        paid_time: "", //	bigint NULL	When was the ticket paid
        epaid_by_user_id: "", //	bigint NULL	Who paid the ticket
        epaid_shop_id: "",
        eplayer_id: "", //	bigint NULL
        // eonline_player_id: "",
        ethird_party_player_id: "",
        test: false,
        reprinted: "",
        reserve_transaction_id: "",
        settle_transaction_id: "",
      },
      extra: {
        free_bet: "",
        bonus_data: "",
        bonus_settle_data: "",
        bonus_amount_used: 0,
        bonus_user_data: "",
        bonus_won_data: "",
      },
      status: ["Open", "Winner", "Lost", "Paid", "Expired"],
      is_valid: [
        "Canceled",
        "Valid",
        "Rejected",
        "Manual Authorization",
        "Authorized",
        "Void",
      ],
      newID: false,
      temp: {},

      resultSetString: "",
      resultSetStringState: null,
      resultSet: [],

      reason: "",
      r: 20,
      n: 90,
    };
  },

  watch: {
    resultSetString(newVal, oldVal) {
      const self = this;
      self.resultSetStringState = null;
      if (newVal != oldVal && newVal) {
        // split by comma and remove empty elements
        const parts = newVal.split(",").filter(function (el) {
          return el.length != 0;
        });

        // trim whitespaces
        parts.forEach((item, i) => {
          parts[i] = parseInt(item.trim()).toString();
        });

        if (parts.length <= self.r) {
          let valid = true;

          // check to see if the elements ar enumbers and between allowed limits 1..n
          parts.forEach((item, i) => {
            if (isNaN(item)) {
              valid = false;
            } else {
              if (!(parseInt(item) > 0 && parseInt(item) <= self.n)) {
                valid = false;
              }
            }
          });

          // check to see if they're unique
          if (new Set(parts).size !== parts.length) {
            valid = false;
          }

          if (valid) {
            self.resultSet = parts;
          } else {
            self.resultSetStringState = false;
          }
        }
      }
    },
  },
  methods: {
    noop() {},
    invalidatePayment() {
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      const data = {
        eticket_id: this.eid,
      };

      this.$store
        .dispatch("ticket/invalidatePayment", data)
        .then((resp) => {
          let msg = "Ticket Payment Invalidated";
          this.showSuccessNotification(msg);
          this.loadData();
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    voidTicket() {
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      const data = {
        eticket_id: this.eid,
      };

      this.$store
        .dispatch("ticket/void", data)
        .then((resp) => {
          let msg = "Ticket voided";
          this.showSuccessNotification(msg);
          this.loadData();
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    showCancelTicket() {
      this.$bvModal.show("bv-modal-reason");
    },
    showReprocess() {
      this.$bvModal.show("bv-modal-reprocess");
    },
    valueOfId(val, table) {
      if (!val) {
        return "";
      }

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const userByID = this.$store.getters["cache/userByID"];
      const shopByID = this.$store.getters["cache/shopByID"];
      const playerByID = this.$store.getters["cacheOnDemand/playerByID"];
      // const onlinePlayerByID = this.$store.getters["cache/onlinePlayerByID"];
      const thirdPartyPlayerByID =
        this.$store.getters["cacheOnDemand/thirdPartyPlayerByID"];

      let data = null;

      switch (table) {
        case "tenants":
          data = tenantByID(val);
          if (data) {
            return data.brand_name;
          }
          break;
        case "users":
          data = userByID(val);
          if (data) {
            return data.username;
          }
          break;
        case "shops":
          data = shopByID(val);
          if (data) {
            return data.name;
          }
          break;
        case "players":
          data = playerByID(val);
          if (data) {
            return `${data.name} ${data.surname}`;
          }
          break;
        /*
        case "onlinePlayers":
          data = onlinePlayerByID(val);
          if (data) {
            return `${data.name} ${data.surname}`;
          }
          break;
        */
        case "thirdPartyPlayers":
          data = thirdPartyPlayerByID(val);
          if (data) {
            return `${data.name} ${data.surname} (${data.email})`;
          }
          break;
      }
      return val;
    },
    loadData() {
      if (this.eid == "") {
        return;
      }
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });
      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch((e) => e),
        this.$store.dispatch("cache/fetch", "users").catch((e) => e),
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
        //this.$store.dispatch("cache/fetch", "players").catch((e) => e),
        // this.$store.dispatch("cache/fetch", "onlinePlayers").catch(e => e),
        //this.$store.dispatch("cache/fetch", "thirdPartyPlayers").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("ticket/read", this.eid)
          .then((resp) => {
            this.temp = resp.data;

            const playerIDs = resp.eplayer_id ? [resp.eplayer_id] : [];
            const thirdPartyPlayerIDs = resp.ethird_party_player_id ? [resp.ethird_party_player_id] : [];

            Promise.all([
              this.$store.dispatch("cacheOnDemand/fetch", {
                key: "players",
                ids: playerIDs,
              }),
              this.$store.dispatch("cacheOnDemand/fetch", {
                key: "thirdPartyPlayers",
                ids: thirdPartyPlayerIDs,
              })
            ]).then(() => {
              this.populateData(resp.data);
            }).catch(err => {
              this.showErrorNotification(err);
            });
          })
          .catch((err) => {
            this.showErrorNotification(err);
          })
          .finally(() => {
            loadDet.close();
          });
      });
    },
    /*
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "ticket/update";
      if (this.newID) {
        apiAction = "ticket/create";
      } else {
        detailsData.eid = this.eid;
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Ticket updated";
          if (this.newID && resp.data.id) {
            this.updateUserId(resp.data.id);
            msg = "Ticket created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    */
    populateData(r) {
      console.log("r", r);

      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.ticket_id = r.ticket_id;
      this.details.pin = r.pin;
      this.details.registration_time = this.mom_unix(
        r.registration_time
      ).format("DD-MM-YY, HH:mm:ss");
      this.details.save_time = this.mom_unix(r.save_time).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.etenant_id = r.etenant_id;
      this.details.eshop_id = r.eshop_id;
      this.details.eterminal_id = r.eterminal_id;
      this.details.euser_id = r.euser_id;
      this.details.eevent_id = r.eevent_id;
      this.details.event_name = r.event_name;
      this.details.event_time = this.mom_unix(r.event_time).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.event_code = r.event_code;
      this.details.is_web_ticket = r.is_web_ticket;
      this.details.selected_numbers = r.selected_numbers;
      this.details.ticket_systems = r.ticket_systems;
      this.details.number_of_lines = r.number_of_lines;
      this.details.total_amount = r.total_amount;
      this.details.stake = r.stake;
      this.details.tax = r.tax;
      this.details.max_winning = r.max_winning;
      this.details.min_winning = r.min_winning;
      this.details.is_valid = r.is_valid;
      this.details.authorized = r.authorized;
      this.details.eauthorized_by_user_id = r.eauthorized_by_user_id;
      this.details.authorization_reason = r.authorization_reason;
      this.details.refusal_reason = r.refusal_reason;
      this.details.cancel_time = this.mom_unix(r.cancel_time).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.ecancel_by_user_id = r.ecancel_by_user_id;
      this.details.cancel_reason = r.cancel_reason;
      this.details.status = r.status;
      this.details.gross_winning_amount = r.gross_winning_amount;
      this.details.net_winning_amount = r.net_winning_amount;
      this.details.winning_tax = r.winning_tax;
      this.details.processing_time = this.mom_unix(r.processing_time).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.eprocessing_routine_id = r.eprocessing_routine_id;
      this.details.expiration_time = this.mom_unix(r.expiration_time).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.paid_time = this.mom_unix(r.paid_time).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.epaid_by_user_id = r.epaid_by_user_id;
      this.details.epaid_shop_id = r.epaid_shop_id;
      this.details.eplayer_id = r.eplayer_id;
      // this.details.eonline_player_id = r.eonline_player_id;
      this.details.ethird_party_player_id = r.ethird_party_player_id;
      this.details.test = typeof r.test != "undefined" ? r.test : false;

      let rep = "";
      if (r.reprinted && r.reprinted.length) {
        const tmp = [];
        r.reprinted.forEach((item) => {
          tmp.push(this.mom_unix(item).format("DD-MM-YY, HH:mm:ss"));
        });
        rep = tmp.join("\n");
      }
      this.details.reprinted = rep;

      this.details.reserve_transaction_id = r.reserve_transaction_id;
      this.details.settle_transaction_id = r.settle_transaction_id;

      this.extra.free_bet = r.free_bet;
      this.extra.bonus_data = r.bonus_data;
      this.extra.bonus_settle_data = r.bonus_settle_data;
      this.extra.bonus_amount_used = r.bonus_amount_used;

      this.extra.bonus_user_data = r.bonus_user_data;
      this.extra.bonus_won_data = r.bonus_won_data;

      this.r = r.r;
      this.n = r.n;
    },
    updateUserId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Ticket", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    mom_unix(val) {
      if (!val)
        return {
          format() {
            return "";
          },
        };
      return moment.unix(val / 1e9);
    },
    resetReasonModal() {
      this.reason = "";
    },
    cancelTicket() {
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      const data = {
        eticket_id: this.eid,
        pin: this.details.pin,
        reason: this.reason,
      };

      this.$bvModal.hide("bv-modal-reason");

      this.$store
        .dispatch("ticket/cancel", data)
        .then((resp) => {
          let msg = "Ticket canceled";
          this.showSuccessNotification(msg);
          this.loadData();
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },

    onReprocess() {
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      const tmpRes = [];
      this.resultSet.forEach((item) => {
        tmpRes.push(parseInt(item));
      });

      const data = {
        eid: this.eid,
        winning_numbers: tmpRes,
      };

      this.$bvModal.hide("bv-modal-reprocess");

      this.$store
        .dispatch("ticket/reprocess", data)
        .then((resp) => {
          let msg = "Ticket reprocessed";
          this.showSuccessNotification(msg);
          this.loadData();
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    extendExpiration() {
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      const data = {
        eid: this.eid,
      };

      this.$bvModal.hide("bv-modal-reprocess");

      this.$store
        .dispatch("ticket/extend", data)
        .then((resp) => {
          let msg = "Ticket reprocessed";
          this.showSuccessNotification(msg);
          this.loadData();
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;
      const tmp = value / 10000;

      return Number(Math.round(tmp + "e" + decimals) + "e-" + decimals).toFixed(
        decimals
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
